<a
    class="badge"
    [class.header]="headerStyle"
    [routerLink]="['/locations', 'l', 'location', location?.id || globalSearchLocation?.locationUid]"
    fxLayout="row"
    fxLayoutAlign="start center"
>
    <!-- location icon -->
    <mat-icon svgIcon="c-location"></mat-icon>

    <!-- location info -->
    <div fxFlex class="info" fxLayout="column">
        <span class="content">
            {{ location?.name || globalSearchLocation?.locationName | ceCustomerPrivacy: 'location' }}
        </span>
        <span>{{
            addressLine ||
                globalSearchLocation?.address ||
                globalSearchLocation?.city ||
                (globalSearchLocation?.country | ceCustomerPrivacy: 'address') ||
                'Location'
        }}</span>
    </div>
</a>
